import {
  anEntityInterface,
  mockTopEntitiesQueryOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockTopEntitiesQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          entities: {
            __typename: 'EntityPage',
            objects: [anEntityInterface()],
          },
          insightConfig: {
            __typename: 'InsightConfig',
            lookbackDays: 2,
          },
        },
      });
    }
  ),
];
